export const chatStateSelector = (state) => {
//  console.log('Full Redux state:', state)
//  console.log('state.chat:', state?.chat)

  if (!state || !state.chat) {
    console.warn('Chat reducer not found in Redux store!')
    return false
  }

  return state.chat.isOpen || false
}

export const chatUnreadCountSelector = (state) => state?.chat?.unreadCount || 0